import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~shared/api";

export const useGetSeasonCardsReportUrl = () => {
  const { fetchData } = useApi();
  const { organizationId, sport, seasonId } = useParams();

  return useQuery({
    queryKey: ["seasonCardsReport", sport, organizationId, seasonId],
    queryFn: async () => {
      return await fetchData({
        url: `${sport}/o/${organizationId}/reports/cards/in/season/${seasonId}`,
      });
    },
    enabled: false,
  });
};
